import Icons from '~/components/ui/Icons';
import Link from '~/components/ui/Link';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

/* Button
 * Possible styles: primary, secondary, tertiary, text
 */

const Button = ({ attrs = {}, className = '', button = {} }) => {
  const {
    style = 'primary',
    text = 'Submit',
    rounded = true,
    size = 'regular',
    icon,
  } = button;

  const elementAttrs = {
    className: cn('button relative', {
      [`button--${style}`]: !!style,
      [className]: !!className,
      rounded: rounded,
      [`button--${size}`]: !!size,
    }),
    ...attrs,
  };

  const buttonIcon = style === 'text' && icon && (
    <Icons
      type={icon}
      className={cn('w-5 h-5 absolute center-vertical right-0', {
        'right-6': style !== 'text',
      })}
    />
  );

  if (attrs.to) {
    return (
      <Link {...elementAttrs} onClick={attrs.onClick}>
        {text} {buttonIcon}
      </Link>
    );
  }

  return (
    <button {...elementAttrs} onClick={attrs.onClick}>
      {text}
      {buttonIcon}
    </button>
  );
};

Button.propTypes = {
  attrs: PropTypes.shape({
    onClick: (props, _propName, componentName) => {
      if (!props.onClick && !props.to) {
        return new Error(
          `One of props 'onClick' or 'to' was not specified in '${componentName}'.`,
        );
      }
    },
    // eslint-disable-next-line sonarjs/no-identical-functions
    to: (props, _propName, componentName) => {
      if (!props.onClick && !props.to) {
        return new Error(
          `One of props 'onClick' or 'to' was not specified in '${componentName}'.`,
        );
      }
    },
  }),
  className: PropTypes.string,
  button: PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClick: PropTypes.func,
    style: PropTypes.string,
    arrow: PropTypes.bool,
  }),
};

export default Button;
